module.exports = __webpack_public_path__ + "img/folder_add.ab10b88e.png";